/**
 * Review Belt - horizontal scroll with arrow nav, scoped per instance.
 * Arrows page by one full view (the visible set of whole cards), so the
 * belt always lands on clean card edges. Cards carry data-tags for
 * future segment filtering.
 */
(function () {
  function initReviewBelt(belt) {
    var track = belt.querySelector('[data-belt-track]');
    var prevBtn = belt.querySelector('[data-belt-prev]');
    var nextBtn = belt.querySelector('[data-belt-next]');
    if (!track) return;

    function getStep() {
      var cards = track.querySelectorAll('.review-card');
      if (cards.length < 2) return track.clientWidth;
      var pitch = cards[1].offsetLeft - cards[0].offsetLeft;
      var perView = Math.max(1, Math.round((track.clientWidth + (pitch - cards[0].offsetWidth)) / pitch));
      return pitch * perView;
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) {
        nextBtn.disabled =
          track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  document.querySelectorAll('.review-belt').forEach(initReviewBelt);
})();
